import { type ObtenerUsuarioResponse } from './api.schema';
import { type ObtenerUsuarioUi } from './ui.schema';

export { 
  ObtenerUsuarioResponseSchema,
  type ObtenerUsuarioResponse
} from './api.schema';

export { 
  ObtenerUsuarioUiSchema,
  type ObtenerUsuarioUi 
} from './ui.schema';

export const transformUsuarioApiToUi = (usuario: ObtenerUsuarioResponse): ObtenerUsuarioUi => {
  const capitalizar = (texto: string): string => {
    if (!texto) return '';
    return texto
      .toLowerCase()
      .split(' ')
      .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
      .join(' ');
  };

  const nombreCompleto = `${capitalizar(usuario.nombre || '')} ${capitalizar(usuario.apellido || '')}`.trim();

  const tematica = usuario.tematica && usuario.tematica.nombre 
    ? { id: usuario.tematica.id, nombre: usuario.tematica.nombre }
    : null;

  return {
    id: usuario.id,
    nombreCompleto,
    nombre: usuario.nombre || '',
    apellido: usuario.apellido || '',
    email: usuario.email || '',
    tematica
  };
}; 